import CrmServiceModel from "@/models/CrmServiceModel";
import CustomerModel from "@/models/crm/CustomerModel";
import CustomerLocationModel from "@/models/crm/CustomerLocationModel";

export default class CustomerContactModel extends CrmServiceModel {
  modelName() {
    return 'customer-contacts';
  }
  icon() {
    return 'address-book';
  }
  defaults() {
    return {
      id: null,
      customer_id: null,
      customer: null,
      customer_location_id: null,
      customer_location: null,
      user_id: null,
      user: null,
      first_name: null,
      last_name: null,
      phone_number: null,
      email: null,
      role: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      customer_location_id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      first_name: (val) => (this.nullStringMutator(val)),
      last_name: (val) => (this.nullStringMutator(val)),
      phone_number: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      role: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }
  getCustomerLocation() {
    return this.getRelatedModel(CustomerLocationModel, 'customer_location');
  }
  fullName() {
    return [this.first_name, this.last_name].filter(v=>v).join(' ');
  }
  fullNameAndEmail() {
    return [this.fullName(), (this.email ? `(${this.email})` : null)].filter(v => v).join(' ');
  }
}
